<template>
  <div class="personal-railsbank-form-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-office-building"></i>Edit customer</span>
        
      </div>
      <el-form
        v-if="customerForm"
        :model="customerForm"
        id="customerForm"
        ref="customerForm"
        label-width="200px"
        size="small"
        :rules="customerFormRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-alert v-if="errMsg" :title="errMsg" type="error" show-icon>
        </el-alert>
        <el-row :gutter="50">

          <el-col  :xs="24" :sm="24" :md="12" :lg="12">

            <el-divider content-position="left">Personal</el-divider>

            <el-form-item label="Member Code">
              <el-tag>{{ customerForm.uuid1 }}</el-tag>
            </el-form-item>

            <el-form-item label="Risk Score">
              <el-tag effect="dark" :color="riskColors[customerForm.kyc.personal.riskScore]">{{ customerForm.kyc.personal.riskScore.toUpperCase() }}</el-tag>
             
            </el-form-item>

            <el-form-item prop="firstName" label="Full Name">
              <el-input v-model="customerForm.kyc.personal.firstName"></el-input>
            </el-form-item>

            <el-form-item prop="lastName" label="Last Name">
              <el-input v-model="customerForm.kyc.personal.lastName"></el-input>
            </el-form-item>

            <el-form-item prop="gender" label="Gender">
              <el-select v-model="customerForm.kyc.personal.gender" placeholder="Select">
                <el-option
                  v-for="(item, index) in genderList"
                  :key="index"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="dateOfBirth" label="Date Of Birth">
              <el-date-picker
                v-model="customerForm.kyc.personal.dateOfBirth"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="placeOfBirthCity" label="Place Of Birth City">
              <el-input v-model="customerForm.kyc.personal.placeOfBirthCity"></el-input>
            </el-form-item>


            <el-form-item prop="placeOfBirthCountry" label="Place Of Birth Country">
              <el-select v-model="customerForm.kyc.personal.placeOfBirthCountry" filterable placeholder="Select">
                <el-option
                  v-for="(item, index) in utility.country"
                  :key="index"
                  :label="item.country_name"
                  :value="item.country_code">
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item prop="citizenships" label="Nationality">
              <el-select v-model="customerForm.kyc.personal.citizenships" filterable placeholder="Select">
                <el-option
                  v-for="(item, index) in utility.country"
                  :key="index"
                  :label="item.nationality"
                  :value="item.country_code">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="customerForm.kyc.personal.telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="email" label="Email">
              <el-input
                prefix-icon="el-icon-message"
                v-model="customerForm.kyc.personal.email"
              ></el-input>
            </el-form-item>
           
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left"></el-divider>
            <el-form-item prop="pep" label="PEP">
              <el-switch v-model="customerForm.kyc.personal.isPep"></el-switch>
            </el-form-item>
            <el-form-item prop="accountUsage" label="Account Usage">
              <el-select v-model="customerForm.kyc.personal.accountUsage" placeholder="Select">
                <el-option
                  v-for="(item, index) in accountUsageList"
                  :key="index"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-if="customerForm.kyc.personal.accountUsage == 'other'" prop="accountUsageOther" label="Account Usage Other">
              <el-input v-model="customerForm.kyc.personal.accountUsageOther"></el-input>
            </el-form-item>

            <el-form-item prop="employmentStatus" label="Employment Status">
              <el-select v-model="customerForm.kyc.personal.employmentStatus" placeholder="Select">
                <el-option
                  v-for="(item, index) in workingStatusList"
                  :key="index"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-if="!['unemployed', 'retired'].includes(customerForm.kyc.personal.employmentStatus)" prop="occupation" label="Occupation">
              <el-input v-model="customerForm.kyc.personal.occupation"></el-input>
            </el-form-item>

            
            <el-form-item prop="expectedVolumeRange" label="Expected Volume Range">
              <el-select v-model="customerForm.kyc.personal.expectedVolumeRange" placeholder="Select">
                <el-option
                  v-for="(item, index) in expectedvolumeRangeList"
                  :key="index"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item prop="expectedVolumeCurrency" label="Expected Volume Currency">
              <el-select v-model="customerForm.kyc.personal.expectedVolumeCurrency" placeholder="Select">
                <el-option
                  v-for="item in ['GBP', 'EUR']"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-divider content-position="left">Addrees</el-divider>
            <el-form-item prop="residentialAddressHouseNumber" label="Address House number">
              <el-input v-model="customerForm.kyc.personal.residentialAddressHouseNumber"></el-input>
            </el-form-item>

            <el-form-item prop="residentialAddressStreet" label="Street">
              <el-input v-model="customerForm.kyc.personal.residentialAddressStreet"></el-input>
            </el-form-item>

            <el-form-item prop="residentialAddressCity" label="City">
              <el-input v-model="customerForm.kyc.personal.residentialAddressCity"></el-input>
            </el-form-item>

            <el-form-item prop="residentialAddressPostalCode" label="Zipcode">
              <el-input v-model="customerForm.kyc.personal.residentialAddressPostalCode"></el-input>
            </el-form-item>

            <el-form-item prop="residentialAddressCountry" label="Country">
              <el-select v-model="customerForm.kyc.personal.residentialAddressCountry" filterable placeholder="Select">
                <el-option
                  v-for="(item, index) in utility.country"
                  :key="index"
                  :label="item.country_name"
                  :value="item.country_code">
                </el-option>
              </el-select>
            </el-form-item>


            
          </el-col>
        </el-row>
      </el-form>
      <div class="footer text-center" style="margin-top: 20px;">
        <el-button type="primary" :loading="submiting" @click="submitCustomer()"
          >Submit</el-button
        >
        <el-button @click="cancelForm">Cancel</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getUtility } from "@/api/customer";
import { updateCustomer } from "@/api/v2/customer";
import { workingStatusList, genderList, accountUsageList, expectedvolumeRangeList} from "@/utils"
export default {
  props: {
    formData: Object
  },
  computed: {
    ...mapGetters(["user_project"]),
    device() {
      return this.$store.state.app.device;
    },
    workingStatusList(){
      return workingStatusList()
    },
    accountUsageList(){
      return accountUsageList()
    },
    genderList(){
      return genderList()
    },
    expectedvolumeRangeList(){
      return expectedvolumeRangeList()
    }
  },
  data() {
    return {
      submiting: false,
      dialogShow: false,
      errMsg: "",
      utility: {},
      customerForm: null,
      customerFormRules: {},//model.rules,
      riskColors: {
        low: "#2ecc71",
        lowMedium: "#3498db",
        medium: "#f9b54a",
        mediumHigh: "#fd5847",
        high: "#bf1200"
      },
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
        }
      });
    },

    updateCustomer() {
      if(['unemployed', 'retired'].includes(this.customerForm.kyc.personal.employmentStatus)){
        this.customerForm.kyc.personal.occupation = ""
      }

      this.submiting = true;
      this.errMsg = "";

      const formData = {
        kyc: this.customerForm.kyc
      }
      updateCustomer(this.customerForm.enduser_id, formData).then(
        ({ result, message }) => {
          this.submiting = false;
          if (result) {
            this.$notify({
              title: "Success",
              message: `Update Customer successfully`,
              type: "success",
              duration: 2000
            });
            this.cancelForm()
            this.$emit("on-submited", true);
          } else {
            this.errMsg =
              typeof message === "string" ? message : "Update Customer Error";
          }
        }
      );
    },
    submitCustomer() {
     //this.$emit("on-submited", true);
        this.$refs.customerForm.validate((valid) => {
          if (valid) {
            this.updateCustomer();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      
    },
    cancelForm() {

      if(this.$route.query.ref && this.$route.query.ref == 'customer'){
        this.$router.push(`/project/${this.user_project}?tab=customer`);
      }else if( this.$route.query.ref && this.$route.query.ref == 'info'){
        this.$router.push(`/customer/view/${this.user_project}/${this.customerForm.enduser_id}`);
      }else{
        this.$router.push('/customer')
      }
      
    },
    resetForm() {
      if (this.$refs.customerForm) this.$refs.customerForm.resetFields();
    },


  },
  mounted() {
    this.getUtility();
    this.customerForm = this.formData;
  },
};
</script>

<style lang="scss">
.personal-railsbank-form-container {
  .el-form-item--small.el-form-item {
    margin-bottom: 16px;
  }
  .item__label {
    line-height: 30px;
    font-weight: bold;
  }

  .el-form-item__label {
    font-size: 12px;
  }

  .el-divider__text {
    font-weight: bold;
    font-size: 14px;
    color: #424242;
  }

}
</style>